angular.module('vastdesk').
  component('demandPartnerPermissions', {
    bindings: {
      buyerClientUserAccount: '<',
      formName: '@',
      formId: '@',
      objectPersisted: '<',
      demandPartnerCount: '<',
      selectedOptions: '<',
    },
    template: require('../templates/demandPartnerPermissions.html'),
    controllerAs: '$demandPartnerPermissionsCtrl',
    controller: [function () {
      this.isDisabled = () => {
        return this.buyerClientUserAccount && (this.objectPersisted || this.demandPartnerCount <= 1);
      };
    }]
  });
